module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"removeConfirm":"Are you sure you want to delete this role?"},"et":{"removeConfirm":"Are you sure you want to delete this role?"},"ru":{"removeConfirm":"Are you sure you want to delete this role?"}}')
  delete Component.options._Ctor
}
